export const RectangleIcon = ({ className }) => {
  return (
    <svg className={className} width="48" height="58" viewBox="0 0 48 58" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path id="Rectangle 1088" d="M0 0H48V58L24 48L0 58V0Z" fill="currentColor"/>
    </svg>

  )
}